module.exports = {
  languages: ["hu", "en"],
  defaultLanguage: "hu",
}
